import { signal } from '@preact/signals';

/**
 * **La largeur, en signal.**
 *
 * Presque tout ce qui dépend de la largeur se règle en CSS, et doit s'y régler :
 * une mesure prise en JavaScript se trompe dès qu'on tourne le téléphone ou qu'on
 * redimensionne la fenêtre, et il faut alors la reprendre à la main.
 *
 * Il reste un cas que la CSS ne sait pas traiter : un **attribut** dont la valeur
 * dépend de la largeur — l'ouverture d'un `<details>`. On ne peut pas la forcer
 * depuis une feuille de style de façon portable (les moteurs n'exposent pas le
 * même mécanisme d'affichage pour le contenu replié), et la simuler avec un
 * `display` conditionnel casse le bouton natif.
 *
 * Le point de rupture est **le même que celui de `style.css`** : 52 rem. Il n'y en
 * a qu'un dans tout le produit, et le dupliquer ici est le prix d'un attribut.
 */
export const NARROW_QUERY = '(max-width: 52rem)';

const query = window.matchMedia(NARROW_QUERY);
export const narrow = signal<boolean>(query.matches);
query.addEventListener('change', (ev) => (narrow.value = ev.matches));
